// import { useEffect, useState } from "react";
// import LoadingBox from "../../Components/LoadingBox";
// import { API, Headers } from "../../Config";
// import PageHeader from "../../Routes/PageHeader";
// import DataTable from "./components/dataTable";
// import axios from "axios";
// import { message } from "antd";
// import PurchaseForm from "./components/formModal";

// const Purchase = () => {
//   useEffect(() => {
//     loaddata(page, take);
//     AccountsDropdown();
//   }, []);
//   const [loading, setLoading] = useState(false);
//   const [data, setData] = useState([]);
//   const [accounts, setAccounts] = useState([]);
//   const [selectedPurchase, setSelectedPurchase] = useState();
//   const [page, setPage] = useState(1);
//   const [take, setTake] = useState(10);
//   const [meta, setMeta] = useState({});
//   const [openForm, setOpenForm] = useState(false);
//   const relaod = () => {
//     loaddata(page, take);
//     setSelectedPurchase({});
//     setOpenForm(false);
//   };
//   const onChange = (p, t) => {
//     window.scrollTo(0, 0);
//     setPage(p);
//     setTake(t);
//     loaddata(p, t);
//   };

//   const AccountsDropdown = () => {
//     axios
//       .get(API.BASR_URL + API.CHART_OF_ACCOUNTS_LIST + `/child_accounts`, {
//         headers: Headers(),
//       })
//       .then(function (res) {
//         if (res.status === 200) setAccounts(res.data);
//       })
//       .catch(function (error) {
//         message.error("Customers dropdown faild");
//       });
//   };
//   const loaddata = (p, t) => {
//     axios
//       .get(API.BASR_URL + API.PURCHASE + `/?order=DESC&page=${p}&take=${t}`, {
//         headers: Headers(),
//       })
//       .then(function (response) {
//         if (response.status === 200) {
//           let data = response.data;
//           setData(data.data);
//           setMeta(data.meta);
//         } else {
//           message.error("Oops.Something went wrong");
//         }
//         setLoading(false);
//       })
//       .catch(function (error) {
//         message.error("Oops.Something went wrong");
//         setLoading(false);
//       });
//   };
//   const deleteItem = (item) => {
//     axios
//       .delete(`${API.BASR_URL + API.PURCHASE}/${item.id}`, {
//         headers: Headers(),
//       })
//       .then(function (response) {
//         message.success("Deleted Successfully");
//         relaod();
//       })
//       .catch(function (error) {
//         message.error("Oops.Something went wrong");
//         console.log(error);
//       });
//   };
//   const handleForm = () => {
//     setOpenForm(!openForm);
//     setSelectedPurchase({});
//   };
//   const editItem = (item) => {
//     handleForm();
//     setSelectedPurchase(item);
//     AccountsDropdown();
//   };

//   return (
//     <div>
//       <PageHeader
//         breadScrum={`Admin / Purchase`}
//         RightButton={`New / Purchase`}
//         RightClcik={handleForm}
//       />
//       {loading ? (
//         <LoadingBox />
//       ) : (
//         <div>
//           <DataTable
//             data={data}
//             meta={meta}
//             onDelete={(item) => deleteItem(item)}
//             onUpdate={(item) => editItem(item)}
//             onChange={(page, take) => onChange(page, take)}
//           />
//           {openForm && (
//             <PurchaseForm
//               data={data}
//               accounts={accounts}
//               visible={openForm}
//               relaod={() => relaod()}
//               selectedPurchase={selectedPurchase}
//               onClose={handleForm}
//             />
//           )}
//         </div>
//       )}
//     </div>
//   );
// };
// export default Purchase;

import { Input, message } from "antd";
import axios from "axios";
import { useEffect, useRef, useState } from "react";
import LoadingBox from "../../Components/LoadingBox";
import { API, Headers } from "../../Config";
import PageHeader from "../../Routes/PageHeader";
import DataTable from "./components/dataTable";
import PurchaseForm from "./components/formModal";

const Purchase = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [accounts, setAccounts] = useState([]);
  const [selectedPurchase, setSelectedPurchase] = useState(null);
  const [page, setPage] = useState(1);
  const [take, setTake] = useState(10);
  const [meta, setMeta] = useState({});
  const [openForm, setOpenForm] = useState(false);
  const [search, setSearch] = useState("");
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  const isMounted = useRef(true);

  useEffect(() => {
    isMounted.current = true;
    loadData(page, take, search);
    fetchAccounts();

    return () => {
      isMounted.current = false;
    };
  }, [page, take, search]);

  const fetchAccounts = async () => {
    try {
      const response = await axios.get(
        `${API.BASR_URL}${API.CHART_OF_ACCOUNTS_LIST}/child_accounts`,
        { headers: Headers() }
      );
      if (isMounted.current && response.status === 200) {
        setAccounts(response.data);
      }
    } catch (error) {
      if (isMounted.current) {
        message.error("Failed to load accounts");
      }
    }
  };

  const loadData = async (p, t, searchTerm) => {
    setLoading(true);
    try {
      const url = `${API.BASR_URL}${
        API.PURCHASE
      }/?order=DESC&page=${p}&take=${t}${
        searchTerm ? `&search=${encodeURIComponent(searchTerm)}` : ""
      }`;
      const response = await axios.get(url, { headers: Headers() });
      if (isMounted.current && response.status === 200) {
        setData(response.data.data);
        setMeta(response.data.meta);
        setExpandedRowKeys(
          searchTerm ? response.data.data.map((item) => item.id) : []
        );
      } else if (isMounted.current) {
        message.error("Failed to load purchases");
      }
    } catch (error) {
      if (isMounted.current) {
        message.error("Failed to load purchases");
      }
    } finally {
      if (isMounted.current) {
        setLoading(false);
      }
    }
  };

  const handleDelete = async (item) => {
    try {
      await axios.delete(`${API.BASR_URL}${API.PURCHASE}/${item.id}`, {
        headers: Headers(),
      });
      if (isMounted.current) {
        message.success("Deleted successfully");
        loadData(page, take, search);
      }
    } catch (error) {
      if (isMounted.current) {
        message.error("Failed to delete purchase");
      }
    }
  };

  const handleEdit = (item) => {
    setSelectedPurchase(item);
    setOpenForm(true);
    fetchAccounts();
  };

  const handleFormToggle = () => {
    setOpenForm(!openForm);
    setSelectedPurchase(null);
  };

  const handleSearch = (value) => {
    setSearch(value);
    setPage(1);
  };

  const handleTableChange = (p, t) => {
    setPage(p);
    setTake(t);
    window.scrollTo(0, 0);
  };

  return (
    <div>
      <PageHeader
        breadScrum="Admin / Purchase"
        RightButton="New / Purchase"
        RightClcik={handleFormToggle}
      />
      <div
        style={{
          marginBottom: 16,
          display: "flex",
          justifyContent: "flex-end",
        }}
      >
        <Input.Search
          placeholder="Search by box Number"
          onSearch={handleSearch}
          onChange={(e) => handleSearch(e.target.value)}
          allowClear
          style={{ width: 300 }}
        />
      </div>
      {loading ? (
        <LoadingBox />
      ) : (
        <div>
          <DataTable
            data={data}
            meta={meta}
            onDelete={handleDelete}
            onUpdate={handleEdit}
            Onchange={handleTableChange}
            expandedRowKeys={expandedRowKeys}
            setExpandedRowKeys={setExpandedRowKeys}
          />
          {openForm && (
            <PurchaseForm
              data={data}
              accounts={accounts}
              visible={openForm}
              relaod={() => loadData(page, take, search)}
              selectedPurchase={selectedPurchase}
              onClose={handleFormToggle}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default Purchase;
